define('plugin/product/view/ProductCartListView',['require','lib/view/BaseCollectionView','plugin/product/view/ProductCartItemView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var ProductCartItemView = require('plugin/product/view/ProductCartItemView');

    return Parent.extend({

        childView: ProductCartItemView,

        modelEvents: {
            'sync': 'onModelSync',
        },

        childEvents: {
            'delete': 'onDeleteLine',
            'increment': 'onIncrement',
            'decrement': 'onDecrement',
        },

        initialize: function () {
            Parent.prototype.initialize.call(this, arguments);
            this.collection = this.model.get('items');

            var model = this.model;
            //TODO throttle? Debounce?
            this.saveThrottle = _.throttle(function () {
                model.store();
            }, 300);
        },

        onModelSync: function () {
            this.collection = this.model.get('items');
            // Preserve focus across the full list re-render triggered by sync
            var focusSelector = this._captureFocusInList();
            this.safeRender();
            this._restoreFocusInList(focusSelector);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        /**
         * Returns a selector string for the currently focused button if it is
         * inside this list, or null otherwise.
         * Format: "nth-child(<n>) <.class>"  — enough to re-find after re-render.
         */
        _captureFocusInList: function () {
            var active = document.activeElement;
            if (!active || !$.contains(this.el, active)) { return null; }
            var $active = $(active);
            var $item = $active.closest('.full-info--cart_item');
            if (!$item.length) { return null; }
            var itemIndex = $item.parent().children('.full-info--cart_item').index($item);
            var btnClass = null;
            if ($active.hasClass('sb-plus'))       { btnClass = '.sb-plus'; }
            else if ($active.hasClass('sb-minus')) { btnClass = '.sb-minus'; }
            else if ($active.hasClass('sb-delete')){ btnClass = '.sb-delete'; }
            if (btnClass === null) { return null; }
            return { index: itemIndex, btnClass: btnClass };
        },

        _restoreFocusInList: function (focusInfo) {
            if (!focusInfo) { return; }
            var $items = this.$el.find('.full-info--cart_item');
            var $item = $items.eq(focusInfo.index);
            if (!$item.length) { $item = $items.last(); } // item was deleted — fall back to last
            var $btn = $item.find(focusInfo.btnClass).filter(':not([disabled])');
            if (!$btn.length) { $btn = $item.find('.sb-plus'); } // minus became disabled
            if ($btn.length) { $btn.focus(); }
        },

        onDeleteLine: function (view, data) {
            // Capture focus target before the view is destroyed
            var active = document.activeElement;
            var $focusTarget = null;
            if (active && $.contains(view.el, active)) {
                $focusTarget = view.$el.next().find('button:not([disabled])').first();
                if (!$focusTarget.length) {
                    $focusTarget = view.$el.prev().find('button:not([disabled])').first();
                }
            }

            this.collection.remove(data.model);
            this.model.store();

            if ($focusTarget && $focusTarget.length) {
                $focusTarget.focus();
            } else if (active && $.contains(document.body, active) === false || active === document.body) {
                // Cart is now empty — focus the close button
                this.$el.closest('.sb-cart-popup').find('.sb-cart-popup-close').first().focus();
            }
        },

        onIncrement: function (view, data) {
            data.model.set('qty', data.model.get('qty') + 1);
            // model.set triggers render() synchronously via modelEvents;
            // after render UnwrapBehavior updates view.$el — safe to focus now
            view.$('.sb-plus').focus();
            this.saveThrottle();
        },

        onDecrement: function (view, data) {
            var qty = data.model.get('qty');
            data.model.set('qty', qty > 1 ? qty - 1 : 1);
            // If minus is now disabled (qty hit 1) move focus to plus
            var $minus = view.$('.sb-minus');
            ($minus.prop('disabled') ? view.$('.sb-plus') : $minus).focus();
            this.saveThrottle();
        }
        
        
        
    });

});
